/**
 * @description
 */

import Api from '../../path';
import { BusinessObjectIdType } from '@umu/umu-types';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IInput {
    parent_id: string;
    parent_type: BusinessObjectIdType;
    resource_data: string;
}

export interface IOutput {
    status: number;
}

export const bindResourceV2 = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.RESOURCE_BIND_UPD_V2, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const bindResourceV2Sync = fetchDataSync<IInput>(bindResourceV2);
